import { createDataTestSelector } from '../../createDataTestSelector'

export default {
  confirmButton: createDataTestSelector('onboarding-complete-done')
}
